module.exports = __webpack_public_path__ + "img/emoticon-nps-3-off.2b5e3eba.svg";